// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { Addon } from '../_contracts';
import { ArticleHeader, LineHeader } from '../_components/ui';
/**
 * Component capable of rendering the `RelatedArticlesModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let RelatedArticlesModuleUi = class RelatedArticlesModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.articles = [];
    }
    /**
     * @inheritDoc
     */
    get articlesCount() {
        return this.articles.length;
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const unresolvedArticles = this.module.content.useParentRelated && this.parent && this.parent.hasProperty(Addon.RelatedArticles)
            ? this.parent.getProperty(Addon.RelatedArticles)
            : this.module.content.articles;
        const resolvedArticles = [];
        await Promise.all(unresolvedArticles.map(unresolvedArticle => {
            return new Promise((resolve) => {
                return this.relatedService.resolve(unresolvedArticle, {})
                    .then((article) => {
                    resolvedArticles.push({
                        author: article.author,
                        header: this.module.content.header.text || null,
                        theme: null,
                        ads: article.ads || null,
                        cover: article.properties.cover,
                        lead: this.parseLead(article.properties.lead) || null,
                        meta: article.properties.meta || null,
                        options: article.contentProperties,
                        contentProperties: {},
                        parent: null,
                        pdf: null,
                        publicationDate: article.publicationDate,
                        title: article.title,
                        urlPath: article.urlPath
                    });
                    resolve();
                }).catch(error => {
                    if (this.debug) {
                        console.error(error);
                    }
                    resolve();
                });
            });
        })).then(() => {
            this.articles = resolvedArticles;
        }).finally(() => {
            this.articles.length > 0 ? this.onReady() : this.onError();
        });
    }
    parseLead(markup) {
        let html;
        let obj;
        try {
            obj = this.DeMarked.convertMDToObjects(markup);
            html = this.DeMarked.convertObjectsToHTML(obj);
            this.onReady();
            return html;
        }
        catch (e) {
            this.onError(e);
            return '';
        }
    }
};
RelatedArticlesModuleUi = __decorate([
    Component({
        name: 'RelatedArticlesModuleUi',
        components: {
            ArticleHeader,
            LineHeader
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <ul class="related-articles list-unstyled">
    <li v-for="(article, i) in articles" :key="i" class="mt-9 mb-9">
      <ArticleHeader v-bind="{ content: article, eventBus, fallbackImage, shareService, windowService, isMobile, pdfService, parent, relatedService,
        isLazy: true, isRelated: true }"/>

      <router-link :to="article.urlPath" class="btn btn-primary related-articles__btn mt-5">
        {{ $t('_.read-all') }}
      </router-link>
    </li>
    </ul>
  `
    })
], RelatedArticlesModuleUi);
export { RelatedArticlesModuleUi };
